DiGivCards<div class="contact-container">
  <div class="page-wrapper">
    <!-- Breadcrumb -->
    <app-breadcrumb></app-breadcrumb>

    <!-- Main Wrapper -->
    <div class="contact-main-wrapper" style="margin-top: 2rem; padding: 2rem; background: #f9f9f9; border-radius: 12px;">
      
      <!-- Top Section -->
      <div class="top-wrapper" style="display: flex; justify-content: space-between; align-items: center; gap: 2rem; flex-wrap: wrap;">
        
        <!-- Left Side -->
        <div class="contact-info" style="flex: 1; min-width: 280px;">
          <h2>Let’s Connect & Grow Together</h2>
          <h3>Welcome to <strong>DigivCards.ai</strong></h3>
          <h4>Your Smart Networking Companion</h4>

          <p>
            At <strong>DigivCards.ai</strong>, we’re redefining how professionals connect and share their brand. 
            Our digital vCard platform empowers you to showcase your identity instantly — 
            without the hassle or waste of traditional paper cards.
          </p>

          <p>
            From entrepreneurs to enterprises, we help people create meaningful, eco-friendly connections 
            through beautiful, intelligent, and shareable digital cards.
          </p>

          <p>
            Together, let’s build a smarter, sustainable, and connected future — one tap at a time.
          </p>
        </div>

        <!-- Right Side: Logo -->
        <div class="logo-wrapper" style="flex: 0 0 200px; text-align: center; min-width: 150px;">
          <img src="../../../assets/images/logo.png" alt="DiGivCards Logo" style="max-width: 100%; height: auto;" />
        </div>
      </div>

      <!-- Bottom Section -->
      <div class="bottom-wrapper">
        <div class="container-wrapper">
          <h2>Contact Our Support Team</h2>
          <p>
            Have a question or need assistance? Our team is here to help. 
            Feel free to reach out using the contact options below or send us a quick message using the form.
          </p>

          <div class="help-section">
            <!-- Phone -->
            <a class="help-item" href="tel:+911234567890">
              <mat-icon>phone</mat-icon>
              <div class="help-info">
                <h4>Call Us</h4>
                <p>+91 12345 67890</p>
              </div>
            </a>
            <!-- Email -->
            <a class="help-item" href="mailto:support@digivcards.ai">
              <mat-icon>email</mat-icon>
              <div class="help-info">
                <h4>Email</h4>
                <p>support&#64;digivcards.ai</p>
              </div>
            </a>
            <!-- Address -->
            <a class="help-item" href="https://www.google.com/maps/search/?api=1&query=Chennai,+India" target="_blank">
              <mat-icon>location_on</mat-icon>
              <div class="help-info">
                <h4>Office Address</h4>
                <p>Chennai, Tamil Nadu, India</p>
              </div>
            </a>
            <!-- WhatsApp -->
            <a class="help-item" href="https://wa.me/911234567890" target="_blank">
              <mat-icon>chat</mat-icon>
              <div class="help-info">
                <h4>WhatsApp</h4>
                <p>Chat with us directly</p>
              </div>
            </a>
            <!-- Business Hours -->
            <div class="help-item">
              <mat-icon>access_time</mat-icon>
              <div class="help-info">
                <h4>Business Hours</h4>
                <p>Mon - Fri: 9:00 AM - 6:00 PM</p>
                <p>Sat: 10:00 AM - 4:00 PM</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Contact Form -->
      <div class="contact-form">
        <h2 class="form-header">
          <mat-icon style="vertical-align: middle; margin-right: 8px;">support_agent</mat-icon>
          Get in Touch
        </h2>

        <div class="form-wrapper">
          <h3 class="form-title">We’d Love to Hear from You!</h3>

          <form (ngSubmit)="submitEnquiry()" #enquiryFormRef="ngForm" autocomplete="off">
            <div class="form-group">
              <input
                type="text"
                name="name"
                [(ngModel)]="enquiryForm.name"
                placeholder="Your Name"
                required
              />
            </div>

            <div class="form-group">
              <input
                type="email"
                name="email"
                [(ngModel)]="enquiryForm.email"
                placeholder="Email ID"
                required
                email
              />
            </div>

            <div class="form-group">
              <input
                type="tel"
                name="phone"
                [(ngModel)]="enquiryForm.phone"
                placeholder="Mobile Number"
                required
                pattern="^[0-9]{10}$"
              />
            </div>

            <div class="form-group">
              <textarea
                name="message"
                [(ngModel)]="enquiryForm.message"
                placeholder="Your Message"
                rows="4"
                required
              ></textarea>
            </div>

            <div class="button-wrapper">
              <button type="submit" class="send-btn" [disabled]="submitting">
                <mat-icon style="vertical-align: middle;">send</mat-icon> Send Message
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
